import { IList, IRectSize } from 'annotation-tools/utils';
import {
  IProjectImageInfo,
  IProjectImageInfoType
} from '../../../types/record/image-info';
import { RawRectangleToIRect } from '../../types/common/raw-rectangle';
import {
  IProjectImageInfoAPIValidationErrorFactory,
  IProjectImageInfoAPIValidationErrorType,
  ProjectImageInfoAPIRawSuccessResponseType,
  ProjectImageInfoAPIRawValidationErrorType
} from '../../types/project-image-info/api-response';
import { nullableToStringList } from '../nullable-to-string-list';

export const IProjectImageInfoFromAPISuccessResponse = ({
  id,
  file,
  name,
  width,
  height,
  crop_option,
  annotation_count,
  is_annotated,
  model_id
}: ProjectImageInfoAPIRawSuccessResponseType): IProjectImageInfoType =>
  IProjectImageInfo({
    id,
    fileUri: file,
    name,
    size: IRectSize({ width, height }),
    cropRect: RawRectangleToIRect(crop_option),
    numAnnotations: annotation_count,
    isAnnotated: is_annotated,
    modelId: model_id ?? undefined
  });

export const IProjectImageInfoListFromAPISuccessResponse = (
  list: ProjectImageInfoAPIRawSuccessResponseType[]
): IList<IProjectImageInfoType> =>
  IList<IProjectImageInfoType>(
    list.map(IProjectImageInfoFromAPISuccessResponse)
  );

export const IProjectImageInfoAPIValidationError = ({
  file_guid,
  crop_option,
  model_id,
  name
}: ProjectImageInfoAPIRawValidationErrorType): IProjectImageInfoAPIValidationErrorType =>
  IProjectImageInfoAPIValidationErrorFactory({
    fileGuid: nullableToStringList(file_guid),
    cropRect: nullableToStringList(crop_option),
    modelId: nullableToStringList(model_id),
    name: nullableToStringList(name)
  });
